import React, { Component } from 'react';
import { Button, Col, Input, message, Row, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import {
  queryCancelProtection,
  queryProtectionHistoryList,
  queryProtectionRenewal,
} from '@api/xxcrm/protect';
import { BackBtn } from '@comm/BackBtn';
import { getindustryList } from '@store/modules/industry_list';
import FormAddCus from './FormAddCus';

// import { getAccountInfo } from "../../../store/modules/account_info";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      userName: '',
      addModalVisible: false,
      title: '',
      pageNo: 1,
      total: 0,
    };
  }

  componentWillMount() {
    this.name = '';
  }

  componentDidMount() {
    const { dispatch } = this.props;
    // dispatch(getAccountInfo());
    dispatch(getindustryList());
    this.loadDate(1);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  /**
   * 依据角色判断权限
   */
  judge = accountInfo => {
    const role = accountInfo.roles;
    const permission = {};
    role.map(sign => {
      permission.add =
        sign === '[XxSales]' ||
        sign === '[XxSalesManager]' ||
        sign === '[FinanceMenber]' ||
        sign === '[XZManager]';
      return permission;
    });
  };

  loadDate = pageNo => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.name = this.name;
    this.setState({
      pageNo: current,
    });
    queryProtectionHistoryList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  /**
   * 续保
   */
  protectionRenewal = uuid => {
    queryProtectionRenewal(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadDate();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 取消保护
   */
  protectionCancel = uuid => {
    queryCancelProtection(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadDate();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  handleChange = e => {
    this.setState({
      userName: e.target.value.replace(/\s+/g, ''),
    });
  };

  hideModal = () => {
    this.setState({
      addModalVisible: false,
    });
  };

  search = () => {
    this.name = this.state.userName;
    this.loadDate(this.state.pageNo);
  };

  showModal = (type, uuid) => {
    if (type === 'add') {
      this.setState({
        addModalVisible: true,
        title: '添加保护客户',
      });
    } else if (type === 'edit') {
      this.setState({
        addModalVisible: true,
        title: '修改保护客户',
      });
    }
    this.protectUuid = uuid;
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '公司地址',
        dataIndex: 'area',
        key: 'area',
      },
      {
        title: '行业',
        dataIndex: 'industry',
        key: 'industry',
      },
      {
        title: '保护人',
        dataIndex: 'protectName',
        key: 'protectName',
      },
      {
        title: '保护时间',
        dataIndex: 'protectDate',
        key: 'protectDate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '到期时间',
        dataIndex: 'maturityDate',
        key: 'maturityDate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          return (
            <a className="ant-dropdown-link" onClick={() => this.showModal('edit', record.uuid)}>
              继续保护
            </a>
          );
        },
      },
    ];
  };

  goBack = () => {
    this.props.router.go(-1);
  };

  render() {
    const { data, total } = this.state;

    const pagination = {
      total,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const { addModalVisible, title } = this.state;

    return (
      <div>
        <div className="fixed-header">
          <Row
            type="flex"
            className="protect_search"
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={12} style={{ textAlign: 'left' }}>
              <BackBtn />
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Input
                placeholder="请输入客户名称"
                value={this.state.userName}
                onChange={this.handleChange}
                onPressEnter={this.search}
                style={{ width: '300px' }}
              />
              <Button type="primary" onClick={this.search} style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </Col>
          </Row>
        </div>
        <div style={{ paddingTop: '44px' }}>
          <Table
            rowKey="uuid"
            rowSelection={{}}
            columns={this.columns()}
            dataSource={data}
            pagination={pagination}
          />
        </div>
        {addModalVisible ? (
          <FormAddCus
            cancel={this.hideModal}
            title={title}
            loadDate={this.loadDate}
            protectUuid={this.protectUuid}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({
  list: state.industry_list,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/protect/PageRecord.js